import { atom } from "jotai";

export const selectedClientIdAtom = atom<string>("");
